import {
  arkResponsibilities,
  clientResponsibilities,
  profileFacts,
  type RoleItem,
} from '../content'
import { BrandMark } from './Brand'
import { Cta, Reassurance } from './Cta'
import { Icon } from './Icon'

type RolePanelProps = {
  title: string
  items: RoleItem[]
}

function RolePanel({ title, items }: RolePanelProps) {
  return (
    <article className="role-panel">
      <h3>{title}</h3>
      <ul className="role-list">
        {items.map((item) => (
          <li key={item.label}>
            <Icon name={item.icon} />
            {item.label}
          </li>
        ))}
      </ul>
    </article>
  )
}

function MultilineLabel({ label }: { label: string }) {
  const [first, second] = label.split('\n')
  return (
    <strong>
      {first}
      {second && (
        <>
          <br />
          {second}
        </>
      )}
    </strong>
  )
}

export function EmploymentTalent() {
  return (
    <>
      <section
        className="section section--dark employment"
        aria-labelledby="employment-title"
      >
        <div className="container">
          <div className="reveal">
            <p className="section-number">06 / Employment model</p>
            <h2 className="section-title" id="employment-title">
              Clear roles. One integrated team.
            </h2>
            <p className="section-copy">
              Ark Solutions manages the South African employment infrastructure.
              Your firm leads the professional’s day-to-day work.
            </p>
          </div>
          <div className="role-frame reveal">
            <RolePanel title="Ark Solutions handles" items={arkResponsibilities} />
            <div className="role-bridge" aria-hidden="true">
              <BrandMark />
            </div>
            <RolePanel title="Your team leads" items={clientResponsibilities} />
          </div>
        </div>
      </section>

      <section className="section section--mist" aria-labelledby="talent-title">
        <div className="container">
          <div className="talent-intro reveal">
            <div>
              <p className="section-number">07 / Available talent</p>
              <h2 className="section-title" id="talent-title">
                A carefully selected network is taking shape.
              </h2>
              <p className="section-copy">
                Ark Solutions is assembling a network of qualified CA(SA)
                professionals. Candidate details will be shared with permission
                during a confidential process.
              </p>
            </div>
          </div>
          <div
            className="profile-strip reveal"
            aria-label="Illustrative anonymised professional profile"
          >
            <div className="profile-head">
              <span className="avatar" aria-hidden="true">
                <Icon name="person" />
              </span>
              <strong>
                Illustrative anonymised
                <br />
                CA(SA) professional
              </strong>
            </div>
            {profileFacts.map((fact) => (
              <div className="profile-fact" key={fact.label}>
                <Icon name={fact.icon} />
                <MultilineLabel label={fact.label} />
              </div>
            ))}
          </div>
          <div className="talent-cta reveal">
            <Cta>Tell us what your team needs</Cta>
            <Reassurance ink />
          </div>
        </div>
      </section>
    </>
  )
}
